var map = {
	"./AbstractSegment": 57,
	"./AbstractSegment.js": 57,
	"./Device": 81,
	"./Device/": 81,
	"./Device/Device": 98,
	"./Device/Device.js": 98,
	"./Device/index": 81,
	"./Device/index.js": 81,
	"./SchoolChoices": 181,
	"./SchoolChoices.js": 181,
	"./Scores": 182,
	"./Scores.js": 182,
	"./UserType": 183,
	"./UserType.js": 183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;


//////////////////
// WEBPACK FOOTER
// ./src/shared/bc-segments/segments ^\.\/.*$
// module id = 483
// module chunks = 1